import thunk from 'redux-thunk';
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import {routerMiddleware} from 'react-router-redux'
import rootReducer from '../reducers';
import Aprentis from '../api/Aprentis';

export default function configureStore(history, initialState) {
   const jsonApi = new Aprentis(initialState.conf.api.domain);
   let middleware = applyMiddleware(thunk.withExtraArgument(jsonApi), routerMiddleware(history));

   if (process.env.NODE_ENV === "development") {
      const composeEnhancers = composeWithDevTools({
         // Specify here name, actionsBlacklist, actionsCreators and other options if needed
      });
      middleware = composeEnhancers(middleware);
   }

   const store = createStore(
      rootReducer,
      initialState,
      middleware
   );

   if (module.hot) {
      module.hot.accept('../reducers', () => {
         store.replaceReducer(require('../reducers').default);
      });
   }

   function handleStoreChange() {
      var state = JSON.stringify(store.getState());
      sessionStorage.setItem('sessionInitialState', state);
   }
   store.subscribe(handleStoreChange);

   return store;
}



// WEBPACK FOOTER //
// ./src/store/store.js